export default {
  getChannelData: state => state.channelData,
  getChannelsList: state => state.channelsList,
};
